import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  loader: {
    color: theme.palette.primary.main,
  },
}));
